import React from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import { tUi } from '../../../../../../../../utils/dq_lc';
import {
  SlideTitle,
  PointText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import {
  PledgeLayout,
  LeftContent,
  RightBox,
  IconWrapper,
  PledgeDescription,
  SubmitButton,
} from '../../../../../styles/LearnTab/activity.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const PledgeSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
  uiLocale = 'en-US',
}) => {
  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  return (
    <PledgeLayout>
      <LeftContent>
        {isEditMode ? (
          <CombinedEditableSection
            slide={slide}
            isEditMode={isEditMode}
            slideEdits={slideEdits}
            showEnglishContent={showEnglishContent}
            onSave={onSaveEdit}
            onReset={onResetEdit}
            onCancel={onCancelEdit}
            TitleComponent={SlideTitle}
            ContentComponent={PointText}
          />
        ) : (
          <>
            <SlideTitleHeader
              slide={slide}
              slideEdits={slideEdits}
              showEnglishContent={showEnglishContent}
              highlightWord={highlightWord}
            />
            {renderTextWithId('content_0', slide?.SlideContent, PointText, {}, textRendererOptions)}
          </>
        )}
      </LeftContent>

      <RightBox>
        <IconWrapper />
        <PledgeDescription>{slide?.SlidePledgeContent}</PledgeDescription>
        <SubmitButton>{tUi('slide.pledge.iPledge', uiLocale)}</SubmitButton>
      </RightBox>
    </PledgeLayout>
  );
};

export default PledgeSlide;
